// Country-aware region / province / state options for search filters.
//
// UK uses the 8 SJP canonical regions (see config/uk_postcode_regions.yml)
// because user.province is populated with one of those values by
// User#geocode_me. Using any other UK list here (e.g. ceremonial counties)
// would break the backend filter since no user.province would match.

export const ukSjpRegions = [
  { code: '',         name: 'Any Region', value: '' },
  { code: 'LON',      name: 'London',     value: 'London' },
  { code: 'SE',       name: 'South East', value: 'South East' },
  { code: 'SW',       name: 'South West', value: 'South West' },
  { code: 'MID',      name: 'Midlands',   value: 'Midlands' },
  { code: 'N',        name: 'North',      value: 'North' },
  { code: 'SCO',      name: 'Scotland',   value: 'Scotland' },
  { code: 'WAL',      name: 'Wales',      value: 'Wales' },
  { code: 'NI',       name: 'NI',         value: 'NI' },
  { code: 'OTHER_UK', name: 'Other UK',   value: 'Other UK' },
];

export const canadianProvinces = [
  { code: '',   name: 'Any Province',              nameFr: 'Toute province',            value: '' },
  { code: 'AB', name: 'Alberta',                   nameFr: 'Alberta',                   value: 'Alberta' },
  { code: 'BC', name: 'British Columbia',          nameFr: 'Colombie-Britannique',      value: 'British Columbia' },
  { code: 'MB', name: 'Manitoba',                  nameFr: 'Manitoba',                  value: 'Manitoba' },
  { code: 'NB', name: 'New Brunswick',             nameFr: 'Nouveau-Brunswick',         value: 'New Brunswick' },
  { code: 'NL', name: 'Newfoundland and Labrador', nameFr: 'Terre-Neuve-et-Labrador',   value: 'Newfoundland and Labrador' },
  { code: 'NT', name: 'Northwest Territories',     nameFr: 'Territoires du Nord-Ouest', value: 'Northwest Territories' },
  { code: 'NS', name: 'Nova Scotia',               nameFr: 'Nouvelle-Écosse',           value: 'Nova Scotia' },
  { code: 'NU', name: 'Nunavut',                   nameFr: 'Nunavut',                   value: 'Nunavut' },
  { code: 'ON', name: 'Ontario',                   nameFr: 'Ontario',                   value: 'Ontario' },
  { code: 'PE', name: 'Prince Edward Island',      nameFr: 'Île-du-Prince-Édouard',     value: 'Prince Edward Island' },
  { code: 'QC', name: 'Quebec',                    nameFr: 'Québec',                    value: 'Quebec' },
  { code: 'SK', name: 'Saskatchewan',              nameFr: 'Saskatchewan',              value: 'Saskatchewan' },
  { code: 'YT', name: 'Yukon',                     nameFr: 'Yukon',                     value: 'Yukon' },
];

export const usStates = [
  { code: '',   name: 'Any State',             value: '' },
  { code: 'AL', name: 'Alabama',               value: 'Alabama' },
  { code: 'AK', name: 'Alaska',                value: 'Alaska' },
  { code: 'AZ', name: 'Arizona',               value: 'Arizona' },
  { code: 'AR', name: 'Arkansas',              value: 'Arkansas' },
  { code: 'CA', name: 'California',            value: 'California' },
  { code: 'CO', name: 'Colorado',              value: 'Colorado' },
  { code: 'CT', name: 'Connecticut',           value: 'Connecticut' },
  { code: 'DE', name: 'Delaware',              value: 'Delaware' },
  { code: 'FL', name: 'Florida',               value: 'Florida' },
  { code: 'GA', name: 'Georgia',               value: 'Georgia' },
  { code: 'HI', name: 'Hawaii',                value: 'Hawaii' },
  { code: 'ID', name: 'Idaho',                 value: 'Idaho' },
  { code: 'IL', name: 'Illinois',              value: 'Illinois' },
  { code: 'IN', name: 'Indiana',               value: 'Indiana' },
  { code: 'IA', name: 'Iowa',                  value: 'Iowa' },
  { code: 'KS', name: 'Kansas',                value: 'Kansas' },
  { code: 'KY', name: 'Kentucky',              value: 'Kentucky' },
  { code: 'LA', name: 'Louisiana',             value: 'Louisiana' },
  { code: 'ME', name: 'Maine',                 value: 'Maine' },
  { code: 'MD', name: 'Maryland',              value: 'Maryland' },
  { code: 'MA', name: 'Massachusetts',         value: 'Massachusetts' },
  { code: 'MI', name: 'Michigan',              value: 'Michigan' },
  { code: 'MN', name: 'Minnesota',             value: 'Minnesota' },
  { code: 'MS', name: 'Mississippi',           value: 'Mississippi' },
  { code: 'MO', name: 'Missouri',              value: 'Missouri' },
  { code: 'MT', name: 'Montana',               value: 'Montana' },
  { code: 'NE', name: 'Nebraska',              value: 'Nebraska' },
  { code: 'NV', name: 'Nevada',                value: 'Nevada' },
  { code: 'NH', name: 'New Hampshire',         value: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey',            value: 'New Jersey' },
  { code: 'NM', name: 'New Mexico',            value: 'New Mexico' },
  { code: 'NY', name: 'New York',              value: 'New York' },
  { code: 'NC', name: 'North Carolina',        value: 'North Carolina' },
  { code: 'ND', name: 'North Dakota',          value: 'North Dakota' },
  { code: 'OH', name: 'Ohio',                  value: 'Ohio' },
  { code: 'OK', name: 'Oklahoma',              value: 'Oklahoma' },
  { code: 'OR', name: 'Oregon',                value: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania',          value: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island',          value: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina',        value: 'South Carolina' },
  { code: 'SD', name: 'South Dakota',          value: 'South Dakota' },
  { code: 'TN', name: 'Tennessee',             value: 'Tennessee' },
  { code: 'TX', name: 'Texas',                 value: 'Texas' },
  { code: 'UT', name: 'Utah',                  value: 'Utah' },
  { code: 'VT', name: 'Vermont',               value: 'Vermont' },
  { code: 'VA', name: 'Virginia',              value: 'Virginia' },
  { code: 'WA', name: 'Washington',            value: 'Washington' },
  { code: 'WV', name: 'West Virginia',         value: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin',             value: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming',               value: 'Wyoming' },
];

/**
 * Returns an array of `{ code, name, value }` options for the given country.
 * Falls back to Canadian provinces for unknown countries (existing app behaviour).
 */
export function regionOptionsForCountry(country, locale = 'en') {
  const key = String(country || '').toLowerCase();
  if (key === 'us') return usStates;
  if (key === 'gb') return ukSjpRegions;
  return canadianProvinces.map(p => ({ ...p, name: locale === 'fr' ? (p.nameFr || p.name) : p.name }));
}

/**
 * Label for the country's region/province/state concept.
 */
export function regionLabelForCountry(country) {
  const key = String(country || '').toLowerCase();
  if (key === 'us') return 'State';
  if (key === 'gb') return 'Region';
  return 'Province';
}
